var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDress2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 2C17.311 2 17.8333 2.49746 17.8333 3.11111V4.24401C17.8333 5.70739 17.6816 7.16719 17.3802 8.60215L16.8242 11.25H7.17579L6.61974 8.60215C6.3184 7.16719 6.16663 5.70739 6.16663 4.24401V3.11111C6.16663 2.49746 6.68896 2 7.33329 2H9.5694L10.1514 3.99512C10.382 4.786 11.1381 5.33333 12 5.33333C12.8619 5.33333 13.618 4.786 13.8486 3.99511L14.4306 2H16.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10007 12.75L5.01491 19.4544C4.96206 19.7505 5.05108 20.0528 5.26008 20.287C5.91758 21.0237 7.00425 21.3345 8.01626 21.0753L8.18147 21.033C8.58614 20.9294 9.02118 20.9902 9.37136 21.1995L9.63843 21.3591C11.0685 22.2136 12.9315 22.2136 14.3616 21.3591L14.6286 21.1995C14.9788 20.9902 15.4139 20.9294 15.8185 21.033L15.9837 21.0753C16.9958 21.3345 18.0824 21.0237 18.7399 20.287C18.9489 20.0528 19.0379 19.7505 18.9851 19.4544L16.8999 12.75H7.10007Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress2);
export default __webpack_public_path__ + "static/media/dress-2.782ed7eaee1fbdab8f328fe54e62d0bd.svg";
export { ForwardRef as ReactComponent };